import React from 'react';
import { getStudentDisplayName } from '../../utils/studentName';

/**
 * StudentLinkDropdown - Dropdown to link/unlink students to transcripts
 */
const StudentLinkDropdown = ({
  students,
  selectedUuid,
  onSelect,
  loading,
  disabled
}) => {
  const availableStudents = Array.isArray(students) ? students : [];
  const hasSelectedStudentInOptions = Boolean(
    selectedUuid && availableStudents.some((student) => student.uuid === selectedUuid)
  );

  const handleChange = (e) => {
    const value = e.target.value;
    onSelect(value || null);
  };

  return (
    <div className="student-link-dropdown">
      <label htmlFor="student-select">Link to Student</label>
      <select
        id="student-select"
        value={selectedUuid || ''}
        onChange={handleChange}
        disabled={disabled || loading}
      >
        <option value="">-- No student linked --</option>
        {!hasSelectedStudentInOptions && selectedUuid && (
          <option value={selectedUuid}>
            Linked student (outside current scope)
          </option>
        )}
        {availableStudents.map((student) => (
          <option key={student.uuid} value={student.uuid}>
            {getStudentDisplayName(student)}
          </option>
        ))}
      </select>
      {loading && <span className="link-loading">Saving...</span>}
      {availableStudents.length === 0 && !loading && (
        <span className="no-students-hint">
          No students in current scope
        </span>
      )}
    </div>
  );
};

export default StudentLinkDropdown;
